import { useEffect, useState } from 'react'

import { DEFAULT_LANGUAGE, KLARNA_REGION_WISE_CLIENT_ID_CONFIG } from '@src/config/localisation/locale-config.constants'
import type { TAbsoluteLocale } from '@src/config/localisation/locale-config.types'
import { getSessionStorage } from '@src/utils/enhancedSessionStorage'
import { parseLocale } from '@src/utils/i18n.utils'
import { getNonce } from '@src/utils/nonce.utils'

import isBrowser from '../utils/isBrowser'
declare global {
  interface Window {
    Klarna?: {
      OnsiteMessaging?: {
        refresh: () => void
      }
    }
  }
}
const KLARNA_SESSION_STORAGE_KEY = '__klarna_sdk_default-config'
const isScriptLoadedInBody = () => !!document.querySelector('#klarnaOSM')
const useKlarnaModule = (instalmentSalePrice: number, locale: TAbsoluteLocale = DEFAULT_LANGUAGE) => {
  const { country } = parseLocale(locale)
  const [isScriptLoaded, setIsScriptLoaded] = useState(isBrowser() && isScriptLoadedInBody())
  useEffect(() => {
    if (isScriptLoaded) return
    const script = document.createElement('script')
    const nonce = getNonce()
    script.setAttribute('data-environment', 'production')
    script.setAttribute('async', 'true')
    script.setAttribute('data-client-id', KLARNA_REGION_WISE_CLIENT_ID_CONFIG[country])
    script.setAttribute('id', 'klarnaOSM')
    if (nonce) {
      script.setAttribute('nonce', nonce)
    }
    getSessionStorage().removeItem(KLARNA_SESSION_STORAGE_KEY)
    script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js'
    document.body.appendChild(script)
    setIsScriptLoaded(true)
  }, [country, isScriptLoaded])
  useEffect(() => {
    if (!isScriptLoaded) return
    isBrowser() && window.Klarna?.OnsiteMessaging?.refresh()
  }, [instalmentSalePrice, isScriptLoaded])
  return isScriptLoaded
}
export default useKlarnaModule
